import React, {Component} from 'react';

class CCPlayer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            played: false,
            height: '500',
            parentNode: `JYVideoPlayContainer${Math.round(Math.random() * 10000)}`,
            totalDuration: null
        }
        this.timer = null
    }

    /**
     * 生成指定长度的随机字符串
     * @param {number} length - 字符串长度
     * @returns {string} 随机字符串
     */
    generateNonceString = (length) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const maxPos = chars.length;
        let noceStr = '';
        for (let i = 0; i < (length || 32); i++) {
            noceStr += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return noceStr;
    }

    /**
     * 包装 JS 选项，处理 Android 设备上的函数序列化
     * @param {Object} jsOptions - 原始选项对象
     * @returns {string|Object} 处理后的选项对象
     */
    appOptionsWrapper = (jsOptions) => {
        if (typeof window === 'object') {
            if (window.__appOptionsWrapper) {
                return window.__appOptionsWrapper(jsOptions);
            }
            if (navigator.userAgent.toLowerCase().indexOf('android') !== -1) {
                let jsOptions_copy = { ...jsOptions };
                for (let key in jsOptions_copy) {
                    if (jsOptions_copy[key] instanceof Function) {
                        let newFunString = `${key}_${this.generateNonceString(10)}`;
                        let oldFun = jsOptions_copy[key];
                        window[newFunString] = (...params) => {
                            (async () => {
                                await oldFun(...params);
                            })();
                        };
                        jsOptions_copy[key] = newFunString;
                    }
                }
                return JSON.stringify(jsOptions_copy);
            }
        }
        return jsOptions;
    }

    /**
     * 组件挂载前的生命周期方法，用于初始化视频播放器相关的全局事件监听
     * 设置播放器的各种回调函数到window对象上，包括：
     * - 播放器初始化
     * - 播放开始
     * - 播放暂停
     * - 播放恢复
     * - 播放停止
     * 同时绑定视频时长更新的监听器
     */
    componentWillMount() {
        if (typeof window === 'object') {
            window.on_cc_player_init = this.on_cc_player_init
            window.on_spark_player_start = this.on_spark_player_start
            window.on_spark_player_pause = this.on_spark_player_pause
            window.on_spark_player_resume = this.on_spark_player_resume
            window.on_spark_player_stop = this.on_spark_player_stop
            if (window.__videoplay_listenVideoTimeupdate) window.__videoplay_listenVideoTimeupdate("workPlayer", this.updateDataTotalDuration.bind(this))
        }
    }

    /**
     * 组件挂载后初始化 CC 视频播放器
     * 创建 script 标签并插入播放器容器，根据容器宽度计算播放器高度
     * 处理播放器 URL 参数，替换高度和父节点参数
     * 如果未播放过，设置延时监听器
     * 
     * @param {Object} props.url - CC视频播放器的URL
     * @param {boolean} state.played - 视频是否已播放标记
     * @param {string} state.parentNode - 父节点参数
     */
    componentDidMount() {
        let {url = ''} = this.props
        const {played, parentNode} = this.state
        const script = document.createElement('script')
        const playerContainer = this.refs.playerContainer
        const width = playerContainer.offsetWidth
        const height = Math.ceil(width * 509 / 857)
        playerContainer.appendChild(script)

        if (url) url = url.replace(/height=[0-9]*/, `height=${height}`).replace(/parentNode=.*?&/igm, `parentNode=${parentNode}&`)
        script.src = url
        // 测试用
        // script.src = `https://p.bokecc.com/player?vid=2FFD1B1C770C891A9C33DC5901307461&siteid=1936D297411C3A27&autoStart=true&width=${width}&height=${height}&playerid=6ED7421AB96B522E&playertype=1`

        //计时器
        if (!played) {
            setTimeout(() => {
                this.listener()
            }, 300)
        }
    }

    /**
     * 组件卸载时的生命周期方法
     * 清除定时器，防止内存泄漏
     */
    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    /**
     * 更新音频总时长
     * @param {number} current - 当前播放时间(秒)
     * @param {number} totalDuration - 音频总时长(秒)
     * @memberof CCPlayer
     */
    updateDataTotalDuration = (current, totalDuration) => {
        console.log(current, totalDuration);
        this.setState({totalDuration: totalDuration})
    }

    /**
     * 监听视频播放事件并处理计时逻辑
     * 
     * 该方法负责:
     * - 获取视频元素并添加事件监听
     * - 在视频播放时每10秒更新播放时长计数
     * - 在视频暂停或结束时清除计时器
     * - 如果未找到视频元素则延迟300ms重试
     * 
     * @private
     * @returns {boolean} 如果未找到视频元素返回false
     */
    listener = () => {
        const {timeCounter} = this.props
        const {played} = this.state
        let oVideo = null

        if (timeCounter) {
            const playerContainer = this.refs.playerContainer
            oVideo = playerContainer.getElementsByTagName('video')[0];
            let timer = this.timer
            let _this = this;

            if (oVideo) {
                this.setState({played: true})
                const videoTotalDuration = Math.floor(oVideo.duration)

                if (window.__videoplay_listenVideoTimeupdate) {
                    window.__videoplay_listenVideoTimeupdate("workPlayer", this.updateDataTotalDuration.bind(this))
                }
                oVideo.addEventListener('play', () => {
                    timer = setInterval(() => {
                        const {totalDuration} = _this.state
                        if (totalDuration || totalDuration === 0) timeCounter(totalDuration)
                    }, 10000)
                })
                oVideo.addEventListener('playing', () => {
                    if (!timer) {
                        timer = setInterval(() => {
                            const {totalDuration} = _this.state
                            if (totalDuration || totalDuration === 0) timeCounter(totalDuration)
                        }, 10000)
                    }
                })

                oVideo.addEventListener('pause', () => {
                    clearInterval(timer)
                })
                oVideo.addEventListener('ended', () => {
                    clearInterval(timer)
                })

                // this.setState({totalDuration: videoTotalDuration})
            }
        }

        if (!oVideo && !played) {
            setTimeout(() => {
                this.listener()
            }, 300)
            return false
        }
    }

    /**
     * 初始化CC视频播放器的回调函数
     * @param {string} vid - CC视频的唯一标识符
     * @param {string} objectID - 播放器DOM元素的ID
     * @description 根据浏览器类型获取播放器实例，设置播放状态并禁用右键菜单
     * @private
     */
    on_cc_player_init = (vid, objectID) => {
        const thisMovie = (movieName) => {
            if (navigator.appName.indexOf('Microsoft') !== -1) {
                return window[movieName];
            } else {
                return document[movieName];
            }
        }
        const player = thisMovie(objectID);
        if (player) {
            this.setState({played: true})
            const config = {
                rightmenu_enable: 0
            }
            player.setConfig(config)
        }
    }

    /**
     * 开始播放时的回调函数
     * 如果存在 timeCounter 属性，每10秒调用一次并传入总时长
     * @private
     * @param {void}
     * @returns {void}
     */
    on_spark_player_start = () => {
        const {timeCounter} = this.props
        if (timeCounter) {
            this.timer = setInterval(() => {
                timeCounter(this.state.totalDuration)
            }, 10000)
        }
    }
    /**
     * 暂停播放器时的回调函数
     * 如果存在计时器，则清除计时器
     * @param {void}
     * @returns {void}
     * @private
     */
    on_spark_player_pause = () => {
        const {timeCounter} = this.props
        if (timeCounter) clearInterval(this.timer)
    }
    /**
     * 恢复播放器时的回调函数
     * 如果存在计时器属性且当前没有计时器在运行,
     * 则每10秒触发一次计时器回调,传入总时长
     * @private
     */
    on_spark_player_resume = () => {
        const {timeCounter} = this.props
        if (timeCounter && !this.timer) {
            this.timer = setInterval(() => {
                timeCounter(this.state.totalDuration)
            }, 10000)
        }
    }
    /**
     * 停止播放器时的回调函数
     * 如果存在计时器，则清除计时器
     * @param {void}
     * @returns {void}
     * @private
     */
    on_spark_player_stop = () => {
        const {timeCounter} = this.props
        if (timeCounter) clearInterval(this.timer)
    }

    /**
     * 处理视频点击事件
     * 检查是否在特定应用中，如果是则使用原生播放器
     */
    handleVideoClick = () => {
        const { courseID, sectionID } = this.props;
        const jsBridgeApp = (window.parent || window).JsBridgeApp;
        const userAgent = navigator.userAgent.toLowerCase();
        const isGankaoHD = userAgent.indexOf('gankaohd') > -1;
        const isFeishuo = userAgent.indexOf('feishuo') > -1;
        
        if (jsBridgeApp && jsBridgeApp.openCourseVideo && (isGankaoHD || isFeishuo)) {
            if (courseID && sectionID) {
                const options = this.appOptionsWrapper({
                    courseID: courseID,
                    sectionID: sectionID,
                    recommend: 1
                });
                jsBridgeApp.openCourseVideo(options);
            }
        }
    }

    render() {
        const {style = {width: '100%'}} = this.props
        const {parentNode} = this.state
        if (typeof window !== 'undefined' && navigator.userAgent.indexOf('gankaoHD') > -1) {
            style.width = 'calc(100% * 0.9)';
            style.margin = 'auto';
        }
        return (
            <div 
                style={{...style}} 
                ref={'playerContainer'} 
                id={parentNode}
                onClick={this.handleVideoClick}
            />
        )
    }
}

export default CCPlayer;



// WEBPACK FOOTER //
// ./src/components/word_detail/CCPlayer.js